import React, { useEffect, useState } from "react";
import TableAvatar from "./TableAvatar";
import moment from "moment";
import Breadcrumbs from "../../../components/Breadcrumbs";
import AttendenceModelPopup from "../../../components/modelpopup/AttendenceModelPopup";
import "../../../assets/css/pagination.css";
import {
  getFirstDateOfCurrentMonth,
  getMonthOfCurrentMonth,
} from "../../../utils/formatDateInTimezone";
import { companyID, getEmployeeLocalDetails } from "./../../../auth";
import { months } from "../../../utils/data";
import SearchBox from "../../../components/SearchBox";
import api from "../../../api/axios";
import TooltipWrapper from "../../../utils/TooltipWrapper";
import FilterComponent from "../../../components/FilterComponent";
import { getDepartmentById } from "../../../services/departmentService";
import ExportAttendanceModal from "../../../components/modelpopup/ExportAttendanceModal";
import { Button } from "react-bootstrap";
import { exportAttendanceData } from "../../../services/attendanceService";

const AttendenceAdmin = () => {
  const [showModal, setShowModal] = useState(false);
  const employeeDetails = getEmployeeLocalDetails();
  const [paginationValue, setPaginationValue] = useState(10);
  const [modalData, setModalData] = useState(null);
  const [employeeAttendance, setEmployeeAttendance] = useState([]);
  const [fullAttendanceData, setFullAttendanceData] = useState([]); // New state for full dataset
  const [selectedMonth, setSelectedMonth] = useState(getMonthOfCurrentMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [roleId, setRoleId] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [renderAttendanceData, setRenderAttendanceData] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [monthDates, setMonthDates] = useState([]);
  const [attendanceColor, setAttendanceColor] = useState({});
  const [reRenderAttendanceData, setReRenderAttandanceData] = useState(false);
  const [filterOptions, setFilterOptions] = useState([
    { key: "Active", label: "status", value: [1], category: "Status" },
    { key: "Inactive", label: "status", value: [0], category: "Status" },
    { key: "All Employees", label: "status", value: null, category: "Status" },
  ]);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const employee_role = localStorage.getItem("employee_role");
  const employeeID = localStorage.getItem("employeeID");
  const company_id = companyID();

  useEffect(() => {
    setRoleId(employee_role);
    setEmployeeId(employeeID);
  }, []);

  const month = `${selectedYear}-${selectedMonth}`;
  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() - i
  );

  const attendaceData = async (params = { status: 1 }) => {
    console.log("working...................");
    let start_date = `${selectedYear}-${selectedMonth}-01`;
    const currentMonth = moment().format("YYYY-MM");
    const company_id = companyID();
    try {
      let finalParams = { ...params };
      if (
        employeeDetails.employee_role != 1 &&
        employeeDetails.working_departments?.length
      ) {
        if (!("department_id" in finalParams))
          finalParams.department_id = employeeDetails.working_departments;
      }

      // Add selected employee IDs to the API call - don't add to finalParams as we handle it separately in URL
      // if (selectedEmployeeIds.length > 0) {
      //   finalParams.employee_id = selectedEmployeeIds;
      // }

      const queryParams = new URLSearchParams();
      Object.entries(finalParams).forEach(([key, value]) => {
        if (key === "employee_id") return; // Skip employee_id as we handle it separately
        if (Array.isArray(value)) {
          value.forEach((val) => {
            if (val !== null && val !== undefined && val !== "") {
              queryParams.append(key, val);
            }
          });
        } else {
          queryParams.append(key, value);
        }
      });

      // Build employee_id parameter for URL
      let employeeIdParam = "";
      if (selectedEmployeeIds.length > 0) {
        employeeIdParam = selectedEmployeeIds.join(",");
      }

      const response = await api.get(
        `api/attendance/export/record?company_id=${company_id}&employee_id=${employeeIdParam}&from=${month}&to=${month}&${queryParams.toString()}`
      );
      if (response?.data?.success === true) {
        const fullData = response?.data?.result?.months[0]?.monthRows || [];
        const total_pages =
          fullData.length > 0
            ? Math.ceil(fullData.length / paginationValue)
            : 0;
        const paginatedData = fullData.slice(
          (currentPage - 1) * paginationValue,
          currentPage * paginationValue
        );

        setFullAttendanceData(fullData); // Store full dataset
        setEmployeeAttendance(paginatedData); // Store paginated data
        setTotalPages(total_pages);
        setMonthDates(response?.data?.result?.months[0]?.headerDays);
        setAttendanceColor(response?.data?.result?.legend);
        setRenderAttendanceData(false);
        setCurrentPage(1);
      }
    } catch (err) {
      console.error("error fetching attendance", err);
    }
  };

  const fetchDepartments = async () => {
    try {
      const departments = await getDepartmentById(company_id);
      if (!departments?.result?.length) {
        return;
      }
      const mappedDepartments = departments.result
        .filter((dept) => {
          if (
            employeeDetails.employee_role != 1 &&
            employeeDetails.working_departments?.length
          ) {
            return employeeDetails?.working_departments?.includes(dept.id);
          } else if (employeeDetails.employee_role == 1) {
            return true;
          } else {
            return false;
          }
        })
        .map((dept) => ({
          key: dept.department_name,
          label: "department_id",
          value: dept.id,
          category: "Department",
        }));

      setFilterOptions((prevOptions) => [...prevOptions, ...mappedDepartments]);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  useEffect(() => {
    attendaceData();
    fetchDepartments();
  }, []);

  useEffect(() => {
    attendaceData();
  }, [
    selectedMonth,
    selectedYear,
    renderAttendanceData,
    reRenderAttendanceData,
    selectedEmployeeIds,
  ]);

  // New useEffect to handle pagination changes
  useEffect(() => {
    const paginatedData = fullAttendanceData.slice(
      (currentPage - 1) * paginationValue,
      currentPage * paginationValue
    );
    setEmployeeAttendance(paginatedData);
    const total_pages =
      fullAttendanceData.length > 0
        ? Math.ceil(fullAttendanceData.length / paginationValue)
        : 0;
    setTotalPages(total_pages);
  }, [currentPage, paginationValue, fullAttendanceData]);

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const exportAttendance = async (params) => {
    try {
      await exportAttendanceData(params);
    } catch (error) {
      console.error(error);
    }
  };

  // Handle employee selection change
  const handleEmployeeChange = (employeeId) => {
    console.log(
      "Toggling employee ID:",
      employeeId,
      "Current selected:",
      selectedEmployeeIds
    );

    setSelectedEmployeeIds((prev) => {
      if (prev.includes(employeeId)) {
        // Remove from selection
        const newIds = prev.filter((id) => id !== employeeId);
        console.log("Removing employee. New IDs:", newIds);
        return newIds;
      } else {
        // Add to selection
        const newIds = [...prev, employeeId];
        console.log("Adding employee. New IDs:", newIds);
        return newIds;
      }
    });
  };

  // Handle search input change
  const handleSearchChange = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setLoadingEmployees(true);

    try {
      const response = await api.get(
        `employees/all-employee/${company_id}${value ? `?search=${value}` : ""}`
      );
      if (response.data && response.data.result) {
        const employees = response.data.result;
        const options = employees.map((emp) => ({
          value: emp.employee_id, // Ensure `value` is set to a unique identifier
          label: emp.name || `${emp.first_name} ${emp.last_name}`,
          employee: emp,
        }));
        setEmployeeOptions(options);
      }
    } catch (error) {
      console.error("Error searching employees:", error);
    } finally {
      setLoadingEmployees(false);
    }
  };

  // Remove selected employee
  const removeSelectedEmployee = (employeeId) => {
    setSelectedEmployeeIds((prev) => prev.filter((id) => id !== employeeId));
  };

  // Get selected employees for display
  const getSelectedEmployees = () => {
    return selectedEmployeeIds
      .map((id) => {
        const employee =
          employeeOptions.find((emp) => emp.value === id) ||
          employees.find((emp) => emp.id === id);
        return employee
          ? {
              value: id,
              label:
                employee.label ||
                employee.name ||
                `${employee.first_name} ${employee.last_name}`,
            }
          : null;
      })
      .filter(Boolean);
  };

  const selectedEmployees = getSelectedEmployees();

  // Clean up duplicates in selected employees
  const cleanupDuplicates = () => {
    setSelectedEmployeeIds((prev) => [...new Set(prev)]);
  };

  // Clean up duplicates when needed
  useEffect(() => {
    if (selectedEmployeeIds.length > 0) {
      const uniqueIds = [...new Set(selectedEmployeeIds)];
      if (uniqueIds.length !== selectedEmployeeIds.length) {
        cleanupDuplicates();
      }
    }
  }, [selectedEmployeeIds.length]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".custom-dropdown")) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Load employees on component mount
  useEffect(() => {
    const loadInitialEmployees = async () => {
      try {
        const response = await api.get(`employees/all-employee/${company_id}`);
        if (response.data && response.data.result) {
          const employees = response.data.result;
          setEmployees(employees);

          // Format employees for react-select
          const options = employees.map((emp) => ({
            value: emp.employee_id, // Ensure `value` is set to a unique identifier
            label: emp.name || `${emp.first_name} ${emp.last_name}`,
            employee: emp,
          }));
          setEmployeeOptions(options);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    loadInitialEmployees();
  }, [company_id]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Employees Attendance"
            title="Dashboard"
            subtitle="Employees Attendance"
          />
          <div className="mb-3 d-flex justify-content-end gap-2">
            <div style={{ minWidth: "300px" }} className="custom-dropdown">
              <div className="position-relative">
                <button
                  className="w-100 rounded text-start d-flex justify-content-between align-items-center"
                  type="button"
                  onClick={() => setShowDropdown(!showDropdown)}
                  style={{
                    minHeight: "38px",
                    backgroundColor: "white",
                    border: "1px solid #ced4da",
                    boxShadow: showDropdown
                      ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                      : "none", // Optional focus effect
                    color: "black",
                  }}
                >
                  <span>
                    {selectedEmployees.length > 0
                      ? `${selectedEmployees.length} employee(s) selected`
                      : "Select Employees..."}
                  </span>
                  <i
                    className={`fas fa-chevron-${showDropdown ? "up" : "down"}`}
                  ></i>
                </button>

                {showDropdown && (
                  <div
                    className="dropdown-menu show w-100 p-0"
                    style={{
                      maxHeight: "350px",
                      overflowY: "auto",
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      zIndex: 1000,
                      boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.175)",
                    }}
                  >
                    {/* Search Input */}
                    <div className="p-2 border-bottom">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search employees..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>

                    {/* Loading */}
                    {loadingEmployees && (
                      <div className="text-center py-3">
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <small className="text-muted ms-2">
                          Loading employees...
                        </small>
                      </div>
                    )}

                    {/* Employee List */}
                    {!loadingEmployees && employeeOptions.length > 0 && (
                      <div className="p-0">
                        {employeeOptions.map((employee) => {
                          const isSelected = selectedEmployeeIds.includes(
                            employee.value
                          );

                          return (
                            <div
                              key={employee.value}
                              className={`dropdown-item d-flex align-items-center py-2 px-3 ${
                                isSelected ? "active" : ""
                              }`}
                              style={{
                                backgroundColor: isSelected
                                  ? "#0d6efd"
                                  : "transparent",
                                color: isSelected ? "white" : "black",
                                cursor: "default",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={(e) => {
                                  console.log(employee, "ev");
                                  handleEmployeeChange(employee.value);
                                }}
                                onClick={(e) => {
                                  console.log(e.target.value, "sad");
                                  e.stopPropagation();
                                }}
                                className="me-2"
                                style={{ cursor: "pointer" }}
                              />
                              <span
                                className="text-truncate"
                                style={{ userSelect: "none" }}
                              >
                                {employee.label}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {!loadingEmployees && employeeOptions.length === 0 && (
                      <div className="text-center py-3">
                        <small className="text-muted">
                          {searchTerm
                            ? `No employees found for "${searchTerm}"`
                            : "No employees available"}
                        </small>
                      </div>
                    )}

                    {/* Clear All and Cleanup */}
                    {selectedEmployees.length > 0 && (
                      <div className="p-2 border-top d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-warning flex-fill"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedEmployeeIds([]);
                          }}
                        >
                          Clear All
                        </button>
                        {/* <button
                          type="button"
                          className="btn btn-sm btn-outline-info flex-fill"
                          onClick={(e) => {
                            e.stopPropagation();
                            cleanupDuplicates();
                          }}
                        >
                          Remove Duplicates
                        </button> */}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div>
              <select
                className="form-select"
                value={selectedYear}
                onChange={handleYearChange}
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <select
                className="form-select"
                value={selectedMonth}
                onChange={handleMonthChange}
              >
                {months.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <TooltipWrapper tooltipText="Filter">
                <FilterComponent
                  filterOptions={filterOptions}
                  onApplyFilter={(selectedFilter) => {
                    const queryParams = Object.entries(selectedFilter)?.length
                      ? selectedFilter
                      : { status: 1 };
                    attendaceData(queryParams);
                  }}
                  filterLabel="Filter Employees"
                  resetLabel="Reset Filter"
                  applyLabel="Apply"
                />
              </TooltipWrapper>
            </div>
            <div>
              <Button variant="link" onClick={() => setShowModal(true)}>
                Export Attendance
              </Button>
              <ExportAttendanceModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                exportSheet={exportAttendance}
              />
            </div>
          </div>
          <SearchBox setPaginationValue={setPaginationValue} />
          <TableAvatar
            uniqueDatesForMonth={monthDates}
            paginatedData={employeeAttendance}
            setRenderAttendanceData={setRenderAttendanceData}
            setReRenderAttandanceData={setReRenderAttandanceData}
          />
          {employeeAttendance.length !== 0 && (
            <div className="container mt-3">
              <div className="row justify-content-start attendance-color-code-box">
                {Object.keys(attendanceColor).map(
                  (key) =>
                    attendanceColor[key]?.status != "No Record" && (
                      <div
                        key={key}
                        className="col-6 col-sm-4 col-md-2 d-flex align-items-center mb-2 gap-1"
                      >
                        <div
                          className="circle"
                          style={{
                            backgroundColor: attendanceColor[key].color,
                            color: attendanceColor[key].color,
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                          }}
                        ></div>
                        <span>{attendanceColor[key].status}</span>
                      </div>
                    )
                )}
                {/* <div className="col-6 col-sm-4 col-md-2 d-flex align-items-center mb-2 gap-1">
                  <div
                    className="circle"
                    style={{
                      backgroundColor: "#6d7584",
                      color: "#6d7584",
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                    }}
                  ></div>
                  <span>Ongoing </span>
                </div> */}
              </div>
            </div>
          )}

          <div className="pagination-in-attendance">
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index + 1}
                onClick={() => handlePageChange(index + 1)}
                className={
                  currentPage === index + 1 ? "active btn-primary" : ""
                }
              >
                {index + 1}
              </button>
            ))}
          </div>
          {employeeAttendance?.length == 0 && (
            <div className="row">
              <h1 className="text-center mt-5" style={{ color: "#C7C8CC" }}>
                {" "}
                No Attendance Found
              </h1>
            </div>
          )}
        </div>
      </div>

      {/* {modalData && (
        <AttendenceModelPopup
          data={modalData}
          
        />
      )} */}
    </>
  );
};

export default AttendenceAdmin;
